export default __webpack_public_path__ + "static/media/camera2.61be1d76.svg";